module.exports = __webpack_public_path__ + "static/media/Logo_TELUS_fr.495f43b4.png";